import axiosInstance from '../axiosInterceptor/axiosInstance'

const patchYoutubeConfiguration = (data) => {
  const { orgId, isForChildren } = data
  const url = `v1/orgs/${orgId}/youtube/account/broadcast-settings`
  return axiosInstance.patch(url, { isForChildren })
}

export default patchYoutubeConfiguration
